var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

import _ from 'lodash';

import { editingMode } from 'sdc-cms-writing';
import { fieldValue } from 'sdc-data-models';

import { EntrySelector } from './EntrySelector';
import { EntryLabel } from './EntryLabel';

export var EntryLink = inject('languagesStore', 'typesStore', 'indexStore', 'dataStore', 'editingStore')(observer(function (_ref) {
  var languagesStore = _ref.languagesStore,
      typesStore = _ref.typesStore,
      indexStore = _ref.indexStore,
      field = _ref.field,
      store = _ref.store,
      dataStore = _ref.dataStore,
      editingStore = _ref.editingStore,
      _ref$choices = _ref.choices,
      choices = _ref$choices === undefined ? [] : _ref$choices,
      caption = _ref.caption,
      filter = _ref.filter,
      ignoreIndex = _ref.ignoreIndex;

  if (field.dataType !== 'link') {
    return null;
  }

  if (field.key === 'parent' && dataStore && (!choices || choices.length === 0)) choices = dataStore.dataList;
  if (editingStore.namedStores[field.key] && (!choices || choices.length === 0)) choices = editingStore.namedStores[field.key].dataList;
  var current = fieldValue(store.selected, field.key);
  //const choices = entriesStore.choices[field.linkID] || []
  var type = typesStore.typesByID[field.linkID];
  var name = type.title || 'name';
  var label = typeof caption === 'function' ? caption : function (s) {
    return languagesStore.labelFrom(fieldValue(s, name));
  };
  var filtered = typeof filter === 'function' ? choices.filter(filter) : choices;
  var choiceMap = _.keyBy(choices, 'id');

  var toValue = function toValue(option) {
    return (typeof optint === 'undefined' ? 'undefined' : _typeof(optint)) === 'object' ? option.id : option;
  };
  var isOptionSelected = function isOptionSelected(option, options) {
    var value = toValue(option);
    return _.find(options, 'id') !== undefined;
  };

  if (editingMode.isViewMode.get() || !field.editable) {
    if (current) {
      var showLinks = !ignoreIndex && type.indexed;
      if (field.multiple && _typeof(toJS(current)) === 'object') {
        return React.createElement(
          'div',
          null,
          current.map(function (c) {
            return React.createElement(EntryLabel, { showLinks: showLinks, icon: type.icon, key: c, entry: choiceMap[c], caption: caption });
          })
        );
      } else {
        return React.createElement(
          'div',
          null,
          React.createElement(EntryLabel, { showLinks: showLinks, icon: type.icon, entry: choiceMap[current], caption: caption })
        );
      }
    } else {
      return null;
    }
  } else {
    var toOption = function toOption(s) {
      return s ? {
        value: s.id,
        label: label(s)
      } : undefined;
    };
    var options = filtered.map(toOption);
    if (field.multiple && _typeof(toJS(current)) === 'object') {
      return React.createElement(EntrySelector, {
        value: toJS(current.map(function (id) {
          return choiceMap[id];
        }).map(toOption)),
        isMulti: true,
        options: options, isOptionSelected: isOptionSelected,
        onChange: store.assign(field) });
    } else {
      return React.createElement(EntrySelector, {
        value: toJS(toOption(choiceMap[current])),
        options: options, isOptionSelected: isOptionSelected,
        onChange: store.assign(field) });
    }
  }
}));